module.exports = __webpack_public_path__ + "static/media/2.3.be621e68.png";